import { FC } from 'react'
import { buttonGroupButton } from '../../../components/custom_components/ButtonGroup'
import { PerInfoBox } from '../../../components/custom_components/InfoBox'
import { PerInfoBoxButtonGroupElement } from '../../../components/custom_components/InfoBox/InfoBoxButtonGroup'
import { PerInfoBoxNumberElement } from '../../../components/custom_components/InfoBox/InfoBoxNumberElement'
import { InfoBoxTile } from '../../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import { Col, Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import { EmployeesWithWrongStatusOrMissingContractDto } from '../../../types'

type ResignedEmployeesInfoBoxProps = {
  totalOfEmployees: number
  swichContentButtons?: buttonGroupButton[]
  employeesWithWrongStatusOrMissingContract: EmployeesWithWrongStatusOrMissingContractDto[]
}

export const ResignedEmployeesInfoBox: FC<ResignedEmployeesInfoBoxProps> = ({
  totalOfEmployees,
  employeesWithWrongStatusOrMissingContract,
  swichContentButtons,
}) => {
  const { t } = useTranslation()

  const hasEmployeesWithIssues = !!employeesWithWrongStatusOrMissingContract ? employeesWithWrongStatusOrMissingContract.length > 0 : false

  const renderEmployeeListTooltip = () => {
    if (!hasEmployeesWithIssues) return null

    return (
      <PerFlexRow direction="column">
        <PerText fontSize="s" mb="xxxs">
          {t('employeeList.infoBox.affectedEmployees')}
        </PerText>
        <PerText fontSize="s">{employeesWithWrongStatusOrMissingContract!.map((e) => e.fullName).join(', ')}</PerText>
      </PerFlexRow>
    )
  }

  return (
    <PerInfoBox>
      <InfoBoxTile heading="Resigned" contentFlex="grow">
        <PerInfoBoxNumberElement number={totalOfEmployees} />
      </InfoBoxTile>

      {hasEmployeesWithIssues && (
        <>
          <Divider type="vertical" className="fullHeight" />

          <Col span={6} className="fullHeight">
            <PerFlexRow direction="column" align="middle" className="fullHeight" justify="center">
              <PerButtonCircle
                className="disable-shadow"
                icon="warning_fill"
                color="warning"
                variant="pastel"
                style={{ cursor: 'default' }}
                tooltip={renderEmployeeListTooltip()}
              />
              <PerFlexRow direction="column" mt="xxs">
                <PerText fontSize="xs" color="default">
                  {t('employeeList.infoBox.wrongResignedInfoDisclaimer1')}
                </PerText>
                <PerText fontSize="xs" color="secondary" mt="xxxs">
                  {t('employeeList.infoBox.wrongResignedInfoDisclaimer2')}
                </PerText>
              </PerFlexRow>
            </PerFlexRow>
          </Col>
        </>
      )}

      {swichContentButtons && (
        <>
          <Divider type="vertical" className="fullHeight" />

          <Col span={5} className="fullHeight">
            <InfoBoxTile heading={t('employeeList.infoBox.switchContent')} contentFlex="fixed" headingAlign="center">
              <PerFlexRow direction="column" align="middle" justify="space-between" className="fullHeight">
                <PerText fontSize="xs" color="secondary" appearance="quote" align="center">
                  {t('employeeList.infoBox.switchContentDescription')}
                </PerText>
                <PerInfoBoxButtonGroupElement buttons={swichContentButtons} defaultValue={1} />
              </PerFlexRow>
            </InfoBoxTile>
          </Col>
        </>
      )}
    </PerInfoBox>
  )
}
